import React from "react";
import { DealerListContextProvider } from "./DealerListView";
import DealerList from "./views/DealerList";

const DealerListPage = () => {
  return (
    <DealerListContextProvider>
      <DealerList />
    </DealerListContextProvider>
  );
};

export default DealerListPage;
